import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { get } from "@utils/axios";
import Cookies from 'js-cookie';

// Define a name for slice
const sliceName = "common";

// Define the initial state using that type
const initialState = {
    permissions: JSON.parse(localStorage.getItem("moduleList")),
}
//initial navigation state




export const commonSlice = createSlice({
    name: sliceName,
    initialState,

    reducers: {

        clearPermissions: (state, action) => {
            localStorage.removeItem("moduleList");

            return {
                ...initialState,
                permissions: [],
            };
        },
    },
   
});

export default commonSlice.reducer;
export const { clearPermissions } = commonSlice.actions;
